module.exports = __webpack_public_path__ + "static/media/KNC.282483b1.svg";